import { render, staticRenderFns } from "./FeedManagerNotifications.vue?vue&type=template&id=0fc5bf58&scoped=true&"
import script from "./FeedManagerNotifications.vue?vue&type=script&lang=js&"
export * from "./FeedManagerNotifications.vue?vue&type=script&lang=js&"
import style0 from "./FeedManagerNotifications.vue?vue&type=style&index=0&id=0fc5bf58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc5bf58",
  null
  
)

export default component.exports